import React from 'react';
import {Field} from 'formik';
import {ClickableFormOption, ClickableFormStructure, ClickableOptionWrapper} from '../ClickableFormStructure';

const MultiCheckbox = ({name, label, options, ...rest}) => (
    <ClickableFormStructure name={name} label={label} htmlFor={name}>
        <Field id={name} name={name} {...rest}>
            {({field}) => {
                return options.map((option) => {
                    return (
                        <>
                            <ClickableFormOption
                                checked={field.value.includes(option.value.toString())}
                                checkbox
                                label={option.label}
                                htmlFor={option.value}>
                                <input
                                    type="checkbox"
                                    id={option.value}
                                    {...field}
                                    value={option.value.toString()}
                                    checked={field.value.includes(option.value.toString())}
                                />
                            </ClickableFormOption>
                        </>
                    );
                });
            }}
        </Field>
    </ClickableFormStructure>
);

MultiCheckbox.OptionWrapper = ClickableOptionWrapper;
export {MultiCheckbox, ClickableOptionWrapper};
